const sortCartEndpoints = ({localCartState, availableEndpoints}) => {
    const invalidEndpoints = [];
    const validEndpoints = [];
    localCartState.map(e => {
        const availableEndpoint = availableEndpoints.find(el => el.id === e.endpointId);
        if (!availableEndpoint) {
            invalidEndpoints.push({
                ...e,
                available: false,
                maxQuantity: 0
            });
        } else {
            const maxQuantity = availableEndpoint.labels?.maxPerOrder || availableEndpoint.quantity;
            if (maxQuantity < e.quantity) {
                invalidEndpoints.push({
                    ...e,
                    available: false,
                    quantity: e.quantity - maxQuantity,
                    maxQuantity: 0
                });
                validEndpoints.push({
                    ...e,
                    available: true,
                    quantity: maxQuantity,
                    maxQuantity: maxQuantity
                });
            } else {
                validEndpoints.push({
                    ...e,
                    maxQuantity: maxQuantity,
                    available: true
                });
            }
            
        }
    });
    const sortedEndpoints = [...validEndpoints, ...invalidEndpoints];
    return {
        invalidEndpoints,
        validEndpoints,
        sortedEndpoints,
        hasInvalidEndpoints: !!invalidEndpoints.length
    }
};

export default sortCartEndpoints;